<ng-template #spinnerTemplate>
  <div class="spinner-background">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</ng-template>

@if (loadingService.loading()) {
  <div class="d-flex justify-content-center text-primary loader">
    <ng-container *ngTemplateOutlet="spinnerTemplate"></ng-container>
  </div>
}
